import { render } from "./support-chat.vue?vue&type=template&id=5ad9a7fe&scoped=true"
import script from "./support-chat.vue?vue&type=script&lang=js"
export * from "./support-chat.vue?vue&type=script&lang=js"

import "./support-chat.vue?vue&type=style&index=0&id=5ad9a7fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad9a7fe"]])

export default __exports__